import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M15.88 9.29L12 13.17 8.12 9.29a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.39-1.42 0z",
    fillRule: "evenodd"
  }],
  circles: []
};
var ExpandMoreIcon = function ExpandMoreIcon(props) {
  return renderIcon(props, iconType);
};

export { ExpandMoreIcon };
//# sourceMappingURL=ExpandMoreIcon.esm.js.map
